<div *ngIf="informationMessages && informationMessages.length"
     class="designer-info">
  <i class="icon icon-ic_fluent_info_20_regular"></i>
  <div class="info-message-container">
    <span *ngFor="let info of informationMessages"
          class="info-message">
      {{info.message}}
      <a *ngIf="info.hyperlink"
         href="{{info.hyperlink.src}}"
         target="{{info.hyperlink.target ?? '_self'}}">{{info.hyperlink.text}}</a>
    </span>
  </div>
</div>